import script from "./PreviewMessageFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewMessageFile.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewMessageFile.vue?vue&type=style&index=0&id=4eca46fa&scoped=true&lang=css"
import "./PreviewMessageFile.vue?vue&type=style&index=1&id=4eca46fa&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eca46fa"]])

export default __exports__